import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../node_modules/.pnpm/@linaria_react@3.0.0-beta.15_react@17.0.2/node_modules/@linaria/react/esm/styled.js';
import { getPresets } from '@indriver/vandermeer';
import preset from './preset.js';

var style = getPresets(preset, {
  backgroundColor: 'design',
  contentColor: 'design',
  size: 'size',
  contentSize: 'size',
  iconSize: 'size',
  contentLineHeight: 'size',
  contentFontWeight: 'size'
});

var getBgColor = function getBgColor(props) {
  if (props.disabled) return style.backgroundColor(_extends({}, props, {
    design: 'disabled'
  }));
  if (props.loading) return style.backgroundColor(props);
  return style.backgroundColor(props);
};

var getContentColor = function getContentColor(props) {
  if (props.disabled) return style.contentColor(_extends({}, props, {
    design: 'disabled'
  }));
  return style.contentColor(props);
};

var getOverlayBackground = function getOverlayBackground() {
  return style.overlay();
};

var getContentSize = function getContentSize(props) {
  if (props.isText) return style.contentSize(props);
  return style.iconSize(props);
};

var getContentLineHeight = function getContentLineHeight(props) {
  if (props.isText) return style.contentLineHeight(props);
  return 'normal';
};

var getContentFontWeight = function getContentFontWeight(props) {
  if (props.isText) return style.contentFontWeight(props);
  return 'normal';
};

var getContentBlockSize = function getContentBlockSize(props) {
  if (props.isText) return 'auto';
  return style.iconSize(props);
};

var Box = /*#__PURE__*/styled("div")({
  name: "Box",
  class: "bpa8n00",
  vars: {
    "bpa8n00-0": [getBgColor],
    "bpa8n00-1": [style.size]
  }
});
var Overlay = /*#__PURE__*/styled("div")({
  name: "Overlay",
  class: "o1wuxjtq",
  vars: {
    "o1wuxjtq-0": [getOverlayBackground]
  }
});
var ImageWrapper = /*#__PURE__*/styled("div")({
  name: "ImageWrapper",
  class: "i1jn9r6e"
});
var Image = /*#__PURE__*/styled("img")({
  name: "Image",
  class: "is5gp8e"
});
var ContentWrapper = /*#__PURE__*/styled("div")({
  name: "ContentWrapper",
  class: "c1wls5f0",
  vars: {
    "c1wls5f0-0": [getContentBlockSize],
    "c1wls5f0-1": [getContentSize],
    "c1wls5f0-2": [getContentLineHeight],
    "c1wls5f0-3": [getContentColor],
    "c1wls5f0-4": [getContentFontWeight]
  }
});
var LoaderWrapper = /*#__PURE__*/styled("div")({
  name: "LoaderWrapper",
  class: "lxlis62"
});

export { Box, ContentWrapper, Image, ImageWrapper, LoaderWrapper, Overlay };


require('../../styles-linaria/round-icon/round-icon.styles.css');
